import { z } from "zod";

export const tripBuiltPayloadSchema = z.object({
  vin: z.string(),
  date: z.string(),
  companyUuid: z.string(),
  vehicleUuid: z.string(),
});

export type TripBuiltPayload = z.infer<typeof tripBuiltPayloadSchema>;
